export interface CompositorTransform {
  x: number
  y: number
  width: number
  height: number
  rotation: number
  flipH: boolean
  flipV: boolean
}

export interface CompositorTextStyle {
  fontFamily: string
  fontWeight: string
  fontStyle: string
  fontSize: number
  lineHeight: number
  letterSpacing: number
  textAlign: "left" | "center" | "right"
  verticalAlign: "top" | "center" | "bottom"
  fill: string
  fillOpacity: number
}

export type CompositorLayerType = "background" | "image" | "video" | "text"

export interface CompositorLayer {
  id: string
  name: string
  type: CompositorLayerType
  visible: boolean
  locked: boolean
  transform: CompositorTransform
  opacity: number
  blendMode: string
  textStyle?: CompositorTextStyle
}

export interface CompositorCanvas {
  width: number
  height: number
  duration: number
}

export interface CompositorConfig {
  canvas: CompositorCanvas
  muteAudio: boolean
  layers: CompositorLayer[]
  renderedOutput?: string
}

export const DEFAULT_TRANSFORM: CompositorTransform = {
  x: 0,
  y: 0,
  width: 400,
  height: 300,
  rotation: 0,
  flipH: false,
  flipV: false,
}

export const DEFAULT_TEXT_STYLE: CompositorTextStyle = {
  fontFamily: "Inter",
  fontWeight: "Regular",
  fontStyle: "Normal",
  fontSize: 48,
  lineHeight: 120,
  letterSpacing: 100,
  textAlign: "center",
  verticalAlign: "center",
  fill: "ffffff",
  fillOpacity: 100,
}

export const DEFAULT_COMPOSITOR_CONFIG: CompositorConfig = {
  canvas: { width: 1920, height: 1080, duration: 5 },
  muteAudio: false,
  layers: [
    {
      id: "bg_default",
      name: "Background",
      type: "background",
      visible: true,
      locked: false,
      transform: { x: 0, y: 0, width: 1920, height: 1080, rotation: 0, flipH: false, flipV: false },
      opacity: 100,
      blendMode: "normal",
    },
  ],
}

export const BLEND_MODES = [
  "normal",
  "multiply",
  "screen",
  "overlay",
  "darken",
  "lighten",
  "color-dodge",
  "color-burn",
  "hard-light",
  "soft-light",
  "difference",
  "exclusion",
] as const
